import { setShowModal } from "../../features/auth/authSlice";

export const invalidateAllTagsOnSignInMiddleware =
  (apis: any[]) => (store: any) => (next: any) => (action: any) => {
    if (action.type === "auth/userLoggedIn") {
      apis.forEach((api) => {
        store.dispatch(api?.util?.resetApiState());
        store.dispatch(setShowModal(true));
      });
    }
    return next(action);
  };
